import { render, staticRenderFns } from "./CardFullInvisible.vue?vue&type=template&id=fa985b00&scoped=true"
import script from "./CardFullInvisible.vue?vue&type=script&lang=js"
export * from "./CardFullInvisible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa985b00",
  null
  
)

export default component.exports